import { mergeAttributes, Node } from "@tiptap/core";

import { setNodeViewAttrs } from "@/editor/adapters/utils";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    nwValidationBox: {
      setValidationBox: (attributes?: { id?: string }) => ReturnType;
    };
  }
}

export const NWValidationBoxAdapter = Node.create({
  name: "nw-validation-box",
  group: "block",
  content: "block*",
  atom: true,
  draggable: false,
  selectable: false,

  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: element => element.getAttribute("id"),
      },
      status: {
        default: null,
        parseHTML: element => element.getAttribute("status"),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "nw-validation-box",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "nw-validation-box",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { contentEditable: false }),
      0,
    ];
  },

  addCommands() {
    return {
      setValidationBox:
        attributes =>
        ({ commands }) => {
          return commands.setNode(this.name, attributes);
        },
    };
  },

  addNodeView() {
    return ({ node, editor, getPos }) => {
      const element = document.createElement("nw-validation-box");
      setNodeViewAttrs(element, node.attrs);

      const onStatusChange = ((event: CustomEvent) => {
        editor.commands.command(({ tr, dispatch }) => {
          if (typeof getPos === "function" && dispatch) {
            dispatch(tr.setNodeAttribute(getPos(), "status", event.detail.boxStatus));
            return true;
          }
          return false;
        });
      }) as EventListener;

      element.addEventListener("validation-box-status-changed", onStatusChange);

      return {
        dom: element,
        contentDOM: element,
        update: updatedNode => {
          if (updatedNode.attrs.status !== node.attrs.status) {
            setNodeViewAttrs(element, updatedNode.attrs);
          }
          return true;
        },
        destroy: () => {
          element.removeEventListener("validation-box-status-changed", onStatusChange);
        },
      };
    };
  },
});
